<div class="twodatablock">
  <div class="datablock">
    <div class="inputgroup">
      <label>{{'Selected company'|translate}}:</label>
      <input class="readonly" type="text" readonly="readonly" [value]="GetCurrentCompanyName()" />
    </div>
    <app-entities-list class="app-list" [entities]="myEntities" [filterentities]="targetEntities" [companies]="companies" [company]="currentCompany"
      [IsCopyControl]="IsCopyControl">
    </app-entities-list>
    <div class="manipulation-controls">
      <div>
        <button class="btn_userright" (click)="setTargetCompanyAsOwner()">{{'Change owner'|translate}}</button>
      </div>
    </div>
  </div>
  <div class="vertseparator"></div>
  <div class="datablock">
    <div class="inputgroup">
      <label>{{'Target company'|translate}}:</label>
      <div style="display: flex;">
        <select [(ngModel)]="selectedCompanyId" (ngModelChange)="FillTargetEntities()">
          <option *ngFor="let company of companies" value="{{company.Id}}">
            {{company.Name}}
          </option>
        </select>
      </div>
    </div>
    <app-entities-list class="app-list" *ngIf="targetCompany != undefined" [entities]="targetEntities" [filterentities]="myEntities" [companies]="companies" [company]="GetTargetCompany()"
     [IsCopyControl]="IsCopyControl">
    </app-entities-list>
    <div class="manipulation-controls">
      <div>
        <button class="btn_userleft" (click)="setCurrentCompanyAsOwner()">{{'Change owner'|translate}}</button>
      </div>
    </div>
  </div>
</div>